// アセット相対パス → 配信 URL（純関数。ファイル読み込み・ハッシュ計算なし）。
// キャッシュは Cloudflare Pages の must-revalidate + ETag + デプロイ毎エッジ更新に委ねる
// （差し替え＆再デプロイで反映されるため、URL へのハッシュ付与は不要）。

const ASSET_PREFIX = "assets/";

/**
 * package 相対アセットパス（"assets/br/x.svg"）を配信 URL に変換する。
 * baseUrl は `assets/` 直下をサイトルートとして配信する前提（例: "<base>/br/x.svg"）。
 */
export function assetUrl(baseUrl: string, relPath: string): string {
  const rel = relPath.startsWith(ASSET_PREFIX) ? relPath.slice(ASSET_PREFIX.length) : relPath;
  return `${baseUrl.replace(/\/$/, "")}/${rel}`;
}
